import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { motion } from 'framer-motion';

const Footer = () => {
  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    show: (i = 0) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.1, duration: 0.5 }
    })
  };

  const links1 = [
    { name: 'Boxing Equipments', path: '/our-product-page' },
    { name: 'Factory Tour', path: '/manufacturing-process' },
    { name: 'Contact', path: '/contact' },
    { name: 'Get Quote', path: '/contact' }
  ];

  const links2 = [
    { name: 'About Us', path: '/about' },
    { name: 'Terms & Conditions', path: '/Terms' },
    { name: 'Privacy Policy', path: '/Privacy-policy' }
  ];

  return (
    <footer className="bg-black text-white pt-20 pb-10 relative overflow-hidden">

      {/* Subtle red glow */}
      <div className="absolute inset-0 opacity-20 bg-gradient-to-tr from-red-600 via-transparent to-transparent pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative z-10">

        {/* Top Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-12 mb-16">

          {/* Contact */}
          <motion.div
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            custom={0}
          >
            <h5 className="text-2xl font-orbitron mb-6 relative inline-block">
              Contact Us
              <span className="absolute left-0 -bottom-2 w-16 h-[2px] bg-red-600"></span>
            </h5>

            <div className="space-y-3 text-sm text-gray-300">
              <a href="tel:+971557711247" className="text-lg text-white hover:text-red-500 transition">
                +971 5577 11247
              </a>

              <p>Head Office:</p>
              <p className="leading-relaxed">
                IES Office (50), Wadi Doan Building,<br />
                Al Gharoud, Dubai, UAE
              </p>

              <a
                href="mailto:infiniteexportsolutions@gmail.com"
                className="hover:text-red-500 transition"
              >
                infiniteexportsolutions@gmail.com
              </a>

              <div className="flex gap-4 pt-4">
                <motion.a
                  whileHover={{ scale: 1.15 }}
                  href="https://wa.me/+971557711247"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon icon={faWhatsapp} size="2x" />
                </motion.a>
              </div>
            </div>
          </motion.div>

          {/* Premium Links */}
          <motion.div
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            custom={1}
          >
            <h5 className="text-2xl font-orbitron mb-6 relative inline-block">
              Premium Quality
              <span className="absolute left-0 -bottom-2 w-16 h-[2px] bg-red-600"></span>
            </h5>

            <ul className="space-y-3 text-gray-300">
              {links1.map((item, i) => (
                <motion.li key={i} whileHover={{ x: 6 }}>
                  <Link to={item.path} className="hover:text-red-500 transition">
                    {item.name}
                  </Link>
                </motion.li>
              ))}
            </ul>
          </motion.div>

          {/* Policies */}
          <motion.div
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            custom={2}
          >
            <h5 className="text-2xl font-orbitron mb-6 relative inline-block">
              Company Policy
              <span className="absolute left-0 -bottom-2 w-16 h-[2px] bg-red-600"></span>
            </h5>

            <ul className="space-y-3 text-gray-300">
              {links2.map((item, i) => (
                <motion.li key={i} whileHover={{ x: 6 }}>
                  <Link to={item.path} className="hover:text-red-500 transition">
                    {item.name}
                  </Link>
                </motion.li>
              ))}
            </ul>
          </motion.div>
        </div>

        {/* Bottom Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="flex flex-col lg:flex-row justify-between items-center gap-6 border-t border-white/20 pt-6 text-sm text-gray-400"
        >
          <p>© 2026 Infinite Export Solutions. All Rights Reserved.</p>

          <div className="flex items-center gap-4">
            <span>Safe Payments</span>
            <img
              src="/logo/payments.png"
              alt="payments"
              className="h-8 opacity-80"
            />
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;